"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_client_1 = __importDefault(require("apollo-client"));
const apollo_link_error_1 = require("apollo-link-error");
const apollo_link_http_1 = require("apollo-link-http");
const apollo_link_1 = require("apollo-link");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const promiseToObservable_1 = __importDefault(require("../utils/promiseToObservable"));
class MaydayApolloInstance {
    constructor(TokenService, options = {}) {
        this.TokenService = TokenService;
        this.isProduction = (options === null || options === void 0 ? void 0 : options.isProduction) || true;
        this.commonHeaders = options.commonHeaders || {};
    }
    resolveHeaders(optionHeaders = {}) {
        return Object.assign(Object.assign({}, this.commonHeaders), optionHeaders);
    }
    authRequestInterceptor(options) {
        return new apollo_link_1.ApolloLink((operation, forward) => {
            const headers = this.resolveHeaders(options.headers);
            let bearerToken;
            bearerToken = this.TokenService.get();
            if (bearerToken)
                headers['Authorization'] = `Bearer ${bearerToken}`;
            operation.setContext({ headers });
            return forward(operation);
        });
    }
    handleNetworkError({ networkError, operation, forward }, options) {
        const refreshStatusCode = options.refreshStatusCode || 401;
        if (networkError &&
            'statusCode' in networkError &&
            (networkError === null || networkError === void 0 ? void 0 : networkError.statusCode) !== refreshStatusCode)
            return;
        return (0, promiseToObservable_1.default)(this.TokenService.refreshToken()).flatMap(() => {
            const headers = this.resolveHeaders(options.headers);
            headers['x-no-retry'] = 'true';
            operation.setContext({ headers });
            return forward(operation);
        });
    }
    handleGraphqlError({ graphQLErrors, operation, forward }, options) {
        const refreshMessage = options.refreshMessage || 'UNAUTHENTICATED';
        const unauthenticatedError = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.find((err) => { var _a; return ((_a = err === null || err === void 0 ? void 0 : err.extensions) === null || _a === void 0 ? void 0 : _a.code) === refreshMessage; });
        if (!unauthenticatedError)
            return;
        return (0, promiseToObservable_1.default)(this.TokenService.refreshToken()).flatMap(() => {
            const headers = this.resolveHeaders(options.headers);
            headers['x-no-retry'] = 'true';
            operation.setContext({ headers });
            return forward(operation);
        });
    }
    authErrorResponseInterceptor(options) {
        return (0, apollo_link_error_1.onError)((apolloError) => {
            if (apolloError.networkError)
                return this.handleNetworkError(apolloError, options);
            if (apolloError.graphQLErrors)
                return this.handleGraphqlError(apolloError, options);
            return;
        });
    }
    create(baseURL, options = {}) {
        const httpLink = new apollo_link_http_1.HttpLink({
            uri: baseURL + '/graphql',
        });
        const link = apollo_link_1.ApolloLink.from([
            this.authErrorResponseInterceptor(options),
            this.authRequestInterceptor(options),
            httpLink,
        ]);
        let inMemoryCacheOptions = {};
        if (options.inMemoryCacheOptions) {
            Object.assign(inMemoryCacheOptions, options.inMemoryCacheOptions);
        }
        return new apollo_client_1.default({
            link,
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            connectToDevTools: this.isProduction,
        });
    }
}
exports.default = MaydayApolloInstance;
